var React = require('react');

function LawsOfTheGameBoldInline (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".cls-1{fill:currentColor;}.cls-2{fill:none;}")),React.createElement("path",{"className":"cls-1","d":"M10.84,8.26v21l7.36-6.7,7.36,6.7v-21ZM23.19,23.92,19.8,20.83l-1.6-1.45-1.59,1.45-3.39,3.09V10.63h10Z","key":1}),React.createElement("rect",{"className":"cls-2","width":"35.86","height":"35.86","key":2})]);
}

LawsOfTheGameBoldInline.defaultProps = {"id":"Layer_1","data-name":"Layer 1","viewBox":"0 0 35.86 35.86"};

module.exports = LawsOfTheGameBoldInline;

LawsOfTheGameBoldInline.default = LawsOfTheGameBoldInline;
